<template>
  <div id="app">
    <Start />
    <IconFooter />
  </div>
</template>

<script>
import Start from '@/components/Start'
import IconFooter from '@/components/IconFooter'

export default {
  name: 'App',
  components: {
    Start,
    IconFooter
  }
}
</script>

<style>
@import url("https://use.typekit.net/oxl7ywj.css");
body, html {
  font-family: "futura-pt",sans-serif;
  height: 100%;
}
body {
  padding: 0;
  margin: 0;
  background-color: #000;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  height: 100%;
  width: 100%;
  background-color: #000;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue